import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

const useCustomer = () => {
  const authCtx = useContext(AuthContext);
  const { sendRequest } = useHttp();

  const searchCustomers = async (search, page = 1, limit = 5) => {
    const params = new URLSearchParams();
    if (search) params.append('search', String(search));
    params.append('page', String(page));
    params.append('limit', String(limit));
    return await sendRequest({
      url: `/api/v1/customer?${params.toString()}`,
      method: 'GET',
      headers: authCtx.getAuthHeaders(),
    });
  };

  return { searchCustomers };
};

export default useCustomer;
